<template>
  <div class="device-setting-info-component" data-grm-comp="DeviceSettingInfo" :class="roomInfo.roomType">
    <div class="device-setting-info">
      <div class="device-set-info">
        <div class="device-set-info-header pc">
          <button class="back-btn" @click="handleClickBackBtn"></button>
        </div>
        <transition name="fade">
          <div class="device-set-info-body" v-if="isShowInfo">
            <div class="device-set-info-title-container" v-click-outside="onToggleInfo">
              <div class="device-set-info-room-type">
                <h2 class="device-set-info-room-type-text">{{ roomType }}</h2>
              </div>
              <div class="device-set-info-title-wrapper">
                <p class="device-set-info-title">{{ roomInfo.roomTitle }}</p>
              </div>
              <div class="device-set-info-check-wrapper">
                <p class="device-set-info-check roomDescription" v-html="$t('deviceSetting.info.check')"></p>
              </div>
              <div class="device-set-info-check-wrapper">
                <p class="device-set-info-check roomDescription" v-html="$t('deviceSetting.info.warn')"></p>
              </div>
            </div>
          </div>
        </transition>
        <div class="device-set-info-footer pc">
          <div class="device-set-join-btn-wrapper">
            <button class="default-btn join-request-btn" ref="join" @click="$emit('reqJoin')">{{ $t("deviceSetting.preview.join.title") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Device} from "@/utils";
import {mapGetters} from "vuex";

export default {
  name: 'DeviceSettingInfo',
  props: {
    roomInfo: Object,
    isShowInfo: Boolean,
  },
  computed: {
    ...mapGetters('roomSetting',['roomSetting']),
    roomType() {
      switch (this.roomInfo.roomType) {
        case 'conf':
          return this.$t('common.meeting');
        case 'edu':
          return this.$t('common.edu');
        case 'live':
        case 'wall':
          return this.$t('common.webinar');
        default:
          return '';
      }
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
    if (Device.isMobile()) {
      this.$emit('update:isShowInfo', false)
    }
  },
  mounted() {
    this.$refs.join.focus()
  },
  methods: {
    onToggleInfo() {
      if (!Device.isMobile()) {
        return
      }
      this.toggleInfo()
    },
    toggleInfo() {
      this.$emit('update:isShowInfo', !this.isShowInfo)
    },
    onResize() {
      if (Device.isMobile()) {
        this.$emit('update:isShowInfo', false)
      } else {
        this.$emit('update:isShowInfo', true)
      }
    },
    handleClickBackBtn(){
      if (this.roomSetting.useClosingWindow) {
        window.close();
      } else {
        window.location.href = 'service/room';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/roomType/conf/css/deviceTestInfo';
.device-setting-info-component{
  white-space: pre-line;
}
</style>